import { render, staticRenderFns } from "./Empresas_editar.vue?vue&type=template&id=0fd90aca"
import script from "./Empresas_editar.vue?vue&type=script&lang=js"
export * from "./Empresas_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports